import React, { createContext, useState, useContext } from "react";
export const HomeImagesContext = createContext();

// eslint-disable-next-line react/prop-types
export default function HomeImages({ children }) {
  const [images, setImages] = useState({});

  const resolveImage = (image, arr) => {
    if (!images[image]) {
      setImages((prev) => ({ ...prev, [image]: image }));
      return images[image];
    }
    
    for (let i = 0; i < arr.length; i++) {
      if (!images[arr[i]]) {
        setImages((prev) => ({ ...prev, [arr[i]]: arr[i] }));
        return arr[i];
      }
    }

    return image;
  };

  return (
    <HomeImagesContext.Provider value={{ images, resolveImage }}>
      {children}
    </HomeImagesContext.Provider>
  );
}
export function useHomeImages() {
  return useContext(HomeImagesContext);
}
